@if (!isSaving) {
  <div class="createUserContainer">
    <section id="createSchoolUsersContainer" class="d-flex flex-column">
      @if (backRouterLink) {
        <zbp-button-component
          (clickHandler)="goBack()"
          [iconName]="zbpIconNames.backArrow"
          theme="blackText"
          label="Back To {{backRouterTitle}}"
          class="backButton"
          [role]="'link'">
        </zbp-button-component>
      }
      <header>
        <h1 class="title">{{pageTitle}}</h1>
      </header>
      @if (form) {
        <form
          [formGroup]="form"
          class="mx-auto h-100 styled-form"
          (ngSubmit)="saveUsers()">
          <div class="text-uppercase requiredText">* Required</div>
          @if (usesRoleTypeSelector) {
            <div class="form-group">
              <label class="form-label mb-0" for="roleTypeSelector">
                User Type
              </label>
              <zbp-select
                id="roleTypeSelector"
                [items]="roleTypeOptions"
                bindLabel="label"
                bindValue="value"
                [matchOptionWidth]="true"
                [formControl]="$any(form.controls['roleSelected'])" />
            </div>
          }
          @if (form.controls['roleSelected']?.value) {
            <zbp-branded-manage-users-form
              [roleType]="form.controls['roleSelected']?.value"
              [school]="school"
              [canAddMultipleUsers]="true"
              [showRequiredLabelForAddMode]="false"
              >
            </zbp-branded-manage-users-form>
          }
          <div class="d-flex formButtons mt-auto align-self-end pb-4 pt-2">
            <zbp-button-component
              type="button"
              label="Cancel"
              [useMinWidth]="true"
              theme="ghost"
              (clickHandler)="cancel()"
              >
            </zbp-button-component>
            <zbp-button-component
              type="submit"
              [disabled]="isFormInvalid() || isSaving"
              [tooltip]="isFormInvalid() ? 'Please ensure all required fields are entered.' : ''"
              label="Save"
              [useMinWidth]="true"
              >
            </zbp-button-component>
          </div>
        </form>
      }
    </section>
  </div>
} @else {
  <div class="preloader spinner">
    <zbp-preloader></zbp-preloader>
  </div>
}
